import { NzUploadFile } from "ng-zorro-antd/upload";

export function toUploadFileList(fileNames: string[]): NzUploadFile[] {
    if (!fileNames) return [];
    let i = -1;
    return fileNames.map(fn => <NzUploadFile>{ name: fn, url: `api/_files/${fn}`, status: "done", uid: `${i--}`, thumbUrl: `api/_files/${fn}` })




}
function isImage(fileName: string) {


}